import script from "./Cookies.vue?vue&type=script&setup=true&lang=js"
export * from "./Cookies.vue?vue&type=script&setup=true&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=8cce7e9e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cce7e9e"]])

export default __exports__